import { getFeatureButton } from './feature-button';
import { handleFeatures, synchronizeState } from '../core/handle-features';

let activeFeatures: string[] = [];

export const synchronizeFeaturesState = (featuresWrapper: HTMLElement) => {
  activeFeatures = synchronizeState({
    getFeatureButtonByName: (featureName: string) =>
      getFeatureButton(featuresWrapper, featureName),
  });
};

export const updateFeaturesState = (
  featuresWrapper: HTMLElement,
  featureKey: string,
) => {
  activeFeatures = handleFeatures({
    activeFeatures,
    activatedFeature: featureKey,
    getFeatureButtonByName: (featureName: string) =>
      getFeatureButton(featuresWrapper, featureName),
  });
};
